import { render, staticRenderFns } from "./WinningShares.vue?vue&type=template&id=e2f9a8c0&scoped=true&"
import script from "./WinningShares.vue?vue&type=script&lang=js&"
export * from "./WinningShares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f9a8c0",
  null
  
)

export default component.exports